import React, { useState } from 'react';
import axios from 'axios';
import FacebookLogin from '@greatsumini/react-facebook-login';

function PostForm() {
  const [message, setMessage] = useState('');
  const [link, setLink] = useState('');
  const [image, setImage] = useState('');
  const [accessToken, setAccessToken] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      formData.append('accessToken', accessToken);
      formData.append('message', message);
      formData.append('link', link);
      formData.append('image', image);

      const response = await axios.post(
        'http://localhost:5000/authFacebook/facebook/post',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      console.log('Post successful:', response.data);
    } catch (error) {
      console.error('Error posting to Facebook:', error.response?.data || error.message);
    }
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleFacebookLogin = (response) => {
    console.log('Facebook login successful:', response);
    setAccessToken(response.accessToken);
    localStorage.setItem('accessToken', response.accessToken);
  };

  const handleFacebookLoginFailure = (error) => {
    console.error('Facebook login failed:', error);
  };

  return (
    <div>
      <h3>Post this link to Facebook</h3>
      <FacebookLogin
        appId="your-facebook-app-id" // Replace with your Facebook App ID
        onSuccess={handleFacebookLogin}
        onFail={handleFacebookLoginFailure}
        style={{ marginBottom: '20px' }}
      />
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Post Title"
        />
        <input
          type="text"
          value={link}
          onChange={(e) => setLink(e.target.value)}
          placeholder="Post URL"
        />
        <br />
        <input
          type="file"
          onChange={(e) => handleImageUpload(e)}
          accept="image/*"
        />
        <br />
        {image && <img src={image} alt="Uploaded" style={{ maxWidth: '200px' }} />}
        <br />
        <button type="submit" disabled={!accessToken}>
          Post to Facebook
        </button>
      </form>
    </div>
  );
}

export default PostForm;
